import axios from "axios";
import { SAVED_JOB_POSTS_URL } from "../utils";

export const fetchSavedJobPosts = async () => {
  return axios.get(SAVED_JOB_POSTS_URL);
};
